/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DnsTypes
 */
export interface DnsTypes {
}

/**
 * Check if a given object implements the DnsTypes interface.
 */
export function instanceOfDnsTypes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DnsTypesFromJSON(json: any): DnsTypes {
    return DnsTypesFromJSONTyped(json, false);
}

export function DnsTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DnsTypes {
    return json;
}

export function DnsTypesToJSON(value?: DnsTypes | null): any {
    return value;
}

